import { useEffect, useState } from "react";
import {
    Badge,
    Button,
    Card,
    CardBody,
    Col,
    Container,
    Row,
    Spinner
} from "reactstrap"; 

import { getMyGroups, getProfile } from "../service/authApi";
import { GroupResponseDto, ProfileDto } from "../types/authTypes";
import "../styles/ProfilePage.css";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../context/AuthContext";
const ProfilePage = () => {

    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
   const { role } = useAuth();







    const [profile, setProfile] =
        useState<ProfileDto>();

    useEffect(() => {

        loadProfile();

    }, []);

    const loadProfile = async () => {

        try {

            const response =
                await getProfile();

            setProfile(response);

        }
        finally {

            setLoading(false);

        }

    };

    if (loading)
        return (

            <div className="profile-loading">

                <Spinner />

            </div>

        );

    return (

        <div
  style={{
    minHeight: "100vh",
    background: "#f3f6fb",
    padding: "40px 0",
  }}
>
  <Container>
    <Row className="justify-content-center">
      <Col lg="8">
        <Card
          style={{
            border: "none",
            borderRadius: "20px",
            overflow: "hidden",
            boxShadow: "0 15px 40px rgba(0,0,0,0.12)",
          }}
        >
          {/* Header */}
          <div
  style={{
    background: "linear-gradient(135deg,#2563eb,#4f46e5)",
    color: "#fff",
    textAlign: "center",
    padding: "40px 20px",
    position: "relative",
  }}
>
  

  {/* <div
    style={{
      width: "110px",
      height: "110px",
      borderRadius: "50%",
      background: "#fff",
      color: "#2563eb",
      fontSize: "42px",
      fontWeight: "bold",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto",
    }}
  >
    {profile?.name?.charAt(0)}
  </div> */}

  <h2 className="mt-3">{profile?.name}</h2>

{["Admin", "SuperAdmin", "Coordinator"].includes(role ?? "") && (
  <Badge color="dark" pill>
    {profile?.role}
  </Badge>
)}
</div>
          

          <CardBody style={{ padding: "30px" }}>
            <Row className="g-4">
              <Col md="6">
                <Card
                  body
                  style={{
                    borderRadius: "15px",
                    border: "none",
                    background: "#f8fafc",
                  }}
                >
                  <h6>Email</h6>
                  <p className="mb-0">{profile?.email}</p>
                </Card>
              </Col>

              <Col md="6">
                <Card
                  body
                  style={{
                    borderRadius: "15px",
                    border: "none",
                    background: "#f8fafc",
                  }}
                >
                  <h6>Phone</h6>
                  <p className="mb-0">{profile?.phoneNumber}</p>
                </Card>
              </Col>

              <Col md="6">
                <Card
                  body
                  style={{
                    borderRadius: "15px",
                    border: "none",
                    background: "#f8fafc",
                  }}
                >
                  <h6>Gender</h6>
                  <p className="mb-0">{profile?.gender}</p>
                </Card>
              </Col>


              {["Admin", "SuperAdmin", "Coordinator"].includes(role ?? "") && (

              <Col md="6">
                <Card
                  body
                  style={{
                    borderRadius: "15px",
                    border: "none",
                    background: "#f8fafc",
                  }}
                >
                  <h6>Role</h6>
                  <p className="mb-0">{profile?.role}</p>
                </Card>
              </Col>
              )}

              <Col md="6">
                <Card
                  body
                  style={{
                    borderRadius: "15px",
                    border: "none",
                    background: "#f8fafc",
                  }}
                >
                  <h6>Joined On</h6>
                  <p className="mb-0">
                    {new Date(profile!.createdAt).toLocaleDateString()}
                  </p>
                </Card>
              </Col>

              <Col md="6">
                <Card
                  body
                  style={{
                    borderRadius: "15px",
                    border: "none",
                    background: "#f8fafc",
                  }}
                >
                  <h6>Group Chat</h6>

                  {profile?.isGroupChatAllow ? (
                    <Badge color="success" pill style={{width:"100px"}}>
                      Enabled
                    </Badge>
                  ) : (
                    <Badge color="danger" pill>
                      Disabled
                    </Badge>
                  )}
                </Card>
              </Col>
            </Row>

            <div
              className="d-flex justify-content-between align-items-center mt-4 flex-wrap"
            >
              {profile?.isBlocked ? (
                <Badge color="danger" pill style={{ padding: "10px 15px" }}>
                  Account Blocked
                </Badge>
              ) : (
                <Badge color="success" pill style={{ padding: "10px 15px" }}>
                  Active Account
                </Badge>
              )}

           

            </div>
          </CardBody>
        </Card>
      </Col>
      
    </Row>

  
  </Container>
</div>

    );

};

export default ProfilePage;